
export enum ResultPage {
  AdviceAppt = "ADVICE_APPT",
  AdviceCallback = "ADVICE_CALLBACK",
  DefaultApprovedPostOffer = "DEFAULT_APPROVED_POSTOFFER",
  CSEAppt = "CSE_APPT",
  CSEFutureAppt = "CSE_FUTURE_APPT",
  ERC = "ERC",
  Rates = "RATES",
  Together = "TOGETHER",
  BadCredit = "BAD_CREDIT",
  Coach = "COACH",
  Unaffordable = "UNAFFORDABLE",
  Nurture = "NURTURE",
  TableNoClickout = "TABLE_NO_CLICKOUT",
  TableBrokerOnly = "TABLE_BROKER_ONLY",
}

export enum BooleanEnum {
  true = "TRUE",
  false = "FALSE",
}